import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticPressDownloads = () => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findPressDownloadsSingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query usePressDownloadsQuery {
		squidex {
			findPressDownloadsSingleton {
				id
				data {
					seo {
						de {
							title
							description
						}
					}

					header {
						de {
							title
						}
					}

					content {
						de {
							title
							text
							noDownloadAreas
							noDownloadsInArea
							noFilesInDownload
						}
					}
				}
			}
		}
	}
`;
